import React, { useEffect, useCallback, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components/macro';
import { Container, Box, Grid } from '@material-ui/core';
import Button from 'components/Buttons/Button';
import {
  Prompt,
  StyledContentWrapper,
  StyledDriverExclusionLinkButton,
  ModalHeader
} from 'styles';
import Modal from '../../components/Modal';
import { makeSelectCurrentExcludedDriver } from '../../redux/selectors';

const ButtonGrid = styled(Grid)`
  width: 100%;
  margin: 0 auto;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  text-align: center;
`;

const ModalPrimaryButton = styled(Button)`
  margin: ${props => (props.margin ? props.margin : '0.125rem auto')};
  padding: 8px;
  height: auto;
`;

function ConfirmCovered(props) {
  const {
    location: { pathname },
    history
  } = props;

  const dispatch = useDispatch();
  const prevLocation = useRef(pathname);
  const unListen = useRef();
  // memoize makeSelectCurrentExcludedDriver
  const { driverId } = useParams();
  const selectCurrentExcludedDriver = useMemo(
    makeSelectCurrentExcludedDriver,
    []
  );

  // Pull excluded driver from state
  const excludedDriver = useSelector(state =>
    selectCurrentExcludedDriver(state)
  );

  const backArrowListener = useCallback(() => {
    if (prevLocation !== pathname) {
      history.go(1);
      dispatch({ type: 'OPEN_MODAL', payload: 'driverExclusionModal' });
    }
  }, [history, pathname, dispatch]);

  useEffect(() => {
    if (prevLocation !== pathname) {
      history.push(pathname, '', '');

      unListen.current = history.listen((newLocation, action) => {
        if (action === 'POP') {
          backArrowListener();
        }
      });
    }

    return unListen.current;
  }, [backArrowListener, pathname, history]);

  const handleClose = () => {
    dispatch({ type: 'CLOSE_MODAL' });
  };

  const handleNavigation = () => {
    handleClose();
    dispatch({
      type: 'REDIRECT',
      payload: { url: '/driver-exclusion/start' }
    });
  };

  const { firstName, lastName } = excludedDriver;
  const fullName = `${firstName} ${lastName}`;

  return (
    <Container>
      <StyledContentWrapper>
        <Box m={{ xs: 2, sm: 2, md: 7 }} mx="auto">
          <Prompt>{`Do you want to cover or exclude ${fullName} from your policy?

        If you exclude them, there will not be coverage under this policy when they drive any car.`}</Prompt>
        </Box>
        <StyledDriverExclusionLinkButton
          secondary
          id="cover-button"
          routeTo={`/driver-exclusion/${driverId}/confirm-additional-driver`}
        >
          COVER
        </StyledDriverExclusionLinkButton>
        <StyledDriverExclusionLinkButton
          secondary
          id="exclude-button"
          routeTo={`/driver-exclusion/${driverId}/confirm-dob`}
        >
          EXCLUDE
        </StyledDriverExclusionLinkButton>
      </StyledContentWrapper>
      <Modal
        inline
        modalLabel="DriverExclusionModal"
        modalName="driverExclusionModal"
      >
        <Box>
          <Grid container>
            <ModalHeader>
              {`Clicking 'BACK' will take you to the section start page and reset the list of drivers you've gone through.`}
            </ModalHeader>
            <ButtonGrid container item>
              <Grid item xs sm>
                <ModalPrimaryButton large onClick={handleClose}>
                  CANCEL
                </ModalPrimaryButton>
              </Grid>
              <Grid item xs sm>
                <ModalPrimaryButton primary large onClick={handleNavigation}>
                  BACK
                </ModalPrimaryButton>
              </Grid>
            </ButtonGrid>
          </Grid>
        </Box>
      </Modal>
    </Container>
  );
}

export default ConfirmCovered;
